import { Divider } from '@mui/material';
import React from 'react';
import { DepotAddress, TrackingResponse } from '../../Models';
import { PickupDepotAddress, DepotAddressMap, PostCodeChecker } from '../';

export const ShipmentStatusViewComponent: React.FC<Props> = ({
  Statuses,
  StatusDate,
  Carrier,
  ...divProps
}) => {
  const depotAddressExists = (depot: DepotAddress) =>
    !!depot.city && !!depot.depotName && !!depot.houseNo && !!depot.street && !!depot.zip;

  return (
    <div className="list-box-shadow" {...divProps}>
      <div className="mb-3">
        <strong>
          {StatusDate.toLocaleString('de-DE', { dateStyle: 'long', timeZone: 'UTC' })}
        </strong>
      </div>
      {Statuses.map((Status, ind) => {
        return (
          <div className="d-flex flex-column" key={ind}>
            <div style={{ minHeight: '20px' }} className="d-flex">
              <Divider
                className="align-middle d-inline-block"
                style={{ width: '5px', minHeight: '30px', height: 'auto' }}
                orientation="vertical"
              />
              <div className="d-inline-block align-middle">
                <span className="ms-4 me-2" style={{ whiteSpace: 'nowrap' }}>
                  {new Date(Status?.timeStamp ?? '').toLocaleTimeString('de-DE', {
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: 'UTC'
                  })}
                </span>
              </div>
              <div>
                <strong>
                  <div dangerouslySetInnerHTML={{ __html: Status.label }}></div>
                </strong>
                {String(Status.statusCode) === '990302' && depotAddressExists(Status.depotAddress) && (
                  <PickupDepotAddress Depot={Status.depotAddress} />
                )}
                {String(Status.statusCode) === '990323' && Carrier === 'PIN AG' && <PostCodeChecker />}
              </div>
            </div>
            {String(Status.statusCode) === '990302' && depotAddressExists(Status.depotAddress) && (
              <DepotAddressMap depotAddress={Status.depotAddress} />
            )}
          </div>
        );
      })}
    </div>
  );
};

interface Props
  extends React.DetailedHTMLProps<React.HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  StatusDate: Date;
  Statuses: TrackingResponse[];
  Carrier?: string;
}
